<template>
  <div>
    <div style="text-align: right;padding-bottom: 9px;">
      <b>字典名称：</b>
      <el-input style="width: 120px;"
                v-model="queryParams.para1"
                placeholder="字典名称"/>
      <b>字典类型：</b>
      <el-input style="width: 120px;"
                v-model="queryParams.para2"
                placeholder="字典类型"/>
      <el-button type="primary" @click="getList" size="medium" round><i class="el-icon-search"></i>查询</el-button>
      <el-button type="primary" @click="createdata()" size="medium" round><i class="el-icon-circle-plus"></i>新建
      </el-button>
      <el-button type="warning" @click="cleardata" size="medium" round><i class="el-icon-refresh"></i>重置</el-button>

    </div>
    <el-table v-loading="loading"
              :data="tableData"
              style="width: 100%">
      <el-table-column
          type="index"
          align="center"
          width="70" label="序号">
        <template slot-scope="scope">
          <div v-text="(queryParams.pageNum-1)*queryParams.pageSize+1+scope.$index"></div>
        </template>
      </el-table-column>
      <el-table-column label="字典名称" prop="dictValue" align="center"></el-table-column>
      <el-table-column label="字典类型" prop="dictType" align="center"></el-table-column>
      <el-table-column label="字典状态" prop="status" align="center">
        <template slot-scope="scope">
{{formatestate(scope.row.status)}}
        </template>
      </el-table-column>
      <el-table-column
          align="center" label="操作" width="200">

        <template slot-scope="scope">
          <el-button
              size="mini"
              @click="querydata(scope.row)">
            <i class="el-icon-setting"></i>
            维护字典
          </el-button>

          <el-button v-if="scope.row.status==1"
                     type="danger"
                     size="mini"
                     @click="updatestate(scope.row,0)">
            <i class="el-icon-video-play"></i>
            停用
          </el-button>
          <el-button v-else
                     size="mini"
                     type="success"
                     @click="updatestate(scope.row,1)">
            <i class="el-icon-video-pause"></i>
            启用
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <template>
      <div>
        <pagination
            v-if="total > 0"
            :total="total"
            :center="true"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
        />
      </div>
    </template>
    <el-dialog title="字典维护" :visible.sync="dialogFormVisible"  :close-on-click-modal="false">
      <el-form ref="form" :model="form" id="scfrom">

        <el-form-item label="字典名称:" label-width="105px">
          {{ selectTable.dictValue }}
        </el-form-item>
        <el-form-item label="字典类型:" label-width="105px">
          {{ selectTable.dictType }}
        </el-form-item>
        <el-form-item>
          <p style="    color: red;    font-size: 15px;    margin: 0;">*字典内容不可重复</p>
          <ux-grid border
                   label-width="0px"
                   style="float:left"
                   show-overflow
                   ref="plxTable"
                   :max-height="350"
                   :data="selectTable.tableDatassgzzd"
                   :highlightCurrentRow="false"
                   show-summary
                   :edit-config="{trigger: 'click', mode: 'row'}">

            <ux-table-column field="dictValue" title="名称" width="270" edit-render>
              <template v-slot:edit="scope">
                <el-input v-model="scope.row.dictValue"></el-input>
              </template>
            </ux-table-column>
            <ux-table-column field="dictCode" title="内容" edit-render>
              <template v-slot:edit="scope">
                <el-input v-model="scope.row.dictCode"></el-input>
              </template>
            </ux-table-column>
            <ux-table-column title="操作" width="100">
              <template  v-slot="scope" >
                <el-button @click="delEvent(scope.rowIndex)">删除</el-button>
              </template>
            </ux-table-column>
          </ux-grid>
        </el-form-item>
        <el-form-item label="" label-width="0px" style="">
          <template  v-slot="row" >
          <el-button style="float:left" @click="insertEvent(row)">添加字典</el-button>
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="Submitdc">提 交</el-button>
      </div>
    </el-dialog>
    <el-dialog title="创建字典" :visible.sync="dialogFormVisiblec"  :close-on-click-modal="false">
      <el-form ref="form1" :rules="formRules" :model="form" style="height: 120px">

        <el-form-item label="字典名称:" label-width="105px" prop="dictValue">
          <el-input v-model="form.dictValue"/>
        </el-form-item>
        <el-form-item label="字典类型:" label-width="105px" prop="dictType">
          <el-input v-model="form.dictType"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="Submitdcone">创建</el-button>

        <el-button @click="dialogFormVisiblec=false">关闭</el-button>
      </div>

    </el-dialog>

  </div>

</template>
<script>
import Pagination from "../../component/Pagination/index.vue";

export default {
  components: {Pagination},
  data() {// 自定义权限标识校验
    const dictType = (rule, value, callback) => {
      if (!/^[a-zA-Z][a-zA-Z0-9_:]*$/.test(value)) {
        callback(new Error('权限标识格式不正确（字母开头，可包含字母、数字、冒号、下划线）'));
      } else {
        callback();
      }
    };

// 自定义权限名称校验
    const dictValue = (rule, value, callback) => {
      if (value.length < 2 || value.length > 20) {
        callback(new Error('权限名称长度在 2 到 20 个字符之间'));
      } else {
        callback();
      }
    };
    return {
      formRules: {
        dictType: [
          { required: true, message: '权限标识不能为空', trigger: 'blur' },
          { validator: dictType, trigger: 'blur' }
        ],
        dictValue: [
          { required: true, message: '权限名称不能为空', trigger: 'blur' },
          { validator: dictValue, trigger: 'blur' }
        ]
      },
      selectTable: {
        dictType: '',
        dictValue: '',
        id:'',
        tableDatassgzzd: [],
      },

      file1src: '',
      total: 0,
      pid: '',
      scinfo: {
        id: '',
        scstate: '',
        opinion: ''
      },
      projecttypes: [],
      pwfileList: [],
      form: {
        dictValue: '',
        dictType: '',
        level:''
      },
      dialogpdfVisibledel: false,
      options: [{
        value: '0',
        label: '作废'
      }, {
        value: '1',
        label: '草稿'
      }, {
        value: '2',
        label: '已上报'
      }],
      createvueVisible: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        para1: undefined,
        para2: undefined
      },

      defaultProps: {
        children: "children",
        label: "pname"
      },
      // 菜单列表
      menuOptions: [],
      dialogFormVisible: false,
      dialogFormVisiblec: false,
      dialogFormData: [],
      tableData: [],
      DicData: [],
      tablelistData: [],
      search: '',
      loading: false
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    getDic(val) {
      this.$request.postHttp({
        url: "/system/getDic",
        params: {pname: val},
        success: (data) => {
          this.projecttypes = data.data
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    insertEvent(rowid) {
      let record = {
        dictValue: '',
        dictType: '',
        level:'2',
        parentId:this.selectTable.id

      }
      record.dictType = this.selectTable.dictType
      // 加入行, 表示加入行的row对象，row为空则插入第一行，为-1插入最后一行
      let {row: newRow} = this.$refs.plxTable.insertRow(record, -1)
      // 激活单元格编辑
      this.$refs.plxTable.setActiveRow(newRow)
    },
    formatDate(row) {
      const timestamp = row.completiontime;
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const formattedDate = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;
      return formattedDate;
    },
    delEvent(row) {
      // 删除前可以进行一些操作，比如提示确认
      this.$confirm('此操作将删除该行字典, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log(row)
        // 确认删除时，splice方法会直接修改原数组
        this.selectTable.tableDatassgzzd.splice(row, 1);
        this.$message({
          type: 'success',
          message: '删除成功!提交后上传至服务器'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });


    },
    cleardata() {
      this.queryParams = this.$options.data().queryParams
      this.getList()
    },

    Submitdcone() {
      this.$refs.form1.validate((valid) => {
        if (valid) {
          let diclist = new Array();
          this.form.level='1'
          diclist.push(this.form)
          this.$request.postHttp({
            url: "/system/updiction",
            data: JSON.stringify(diclist),
            success: (data) => {
              if (data.code == 200) {
                this.$message.success('创建字典成功');
                this.dialogFormVisiblec = false
                this.getList()
              } else {
                this.$message.warning(data.msg)
              }

            },
            error: (error) => {

              // 执行失败时的操作
            },
          })
        } else {
          // 校验失败
          this.$message.error('请完善表单信息');
          return false;
        }
      });

    },
    Submitdc() {
      let insertRecords = this.$refs.plxTable.getInsertRecords()
      for (let i = 0; i < insertRecords.length; i++) {
        this.selectTable.tableDatassgzzd.push(insertRecords[i])
      }
      this.$request.postHttp({
        url: "/system/updiction",
        data: JSON.stringify(this.selectTable.tableDatassgzzd),
        success: (data) => {
          this.$message.success('维护字典成功');
          this.dialogFormVisible = false
          this.getList()
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    updatestate(row, state) {
      console.log(row)
      this.$request.postHttp({
        url: "/system/updicstate",
        params: {para1: row.dictType, para2: state},
        success: (data) => {
         this.getList()
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    getList() {
      this.loading = true;
      this.$request.postHttp({
        url: "/system/diclist",
        data: JSON.stringify(this.queryParams),
        success: (data) => {
          this.tableData = data.data.records
          this.total = data.data.total
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
      this.loading = false;
    },

    querydata(row) {
      this.selectTable.dictType = row.dictType
      this.selectTable.dictValue = row.dictValue
      this.selectTable.id=row.id
      this.$request.postHttp({
        url: "/system/getDic",
        params: {pname: row.dictType},
        success: (data) => {
          this.selectTable.tableDatassgzzd = data.data
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
      this.dialogFormVisible = true
    },
    createdata() {
      this.form = this.$options.data().form
      this.dialogFormVisiblec = true;
      if(this.$refs.form1){
        this.$refs.form1.clearValidate();  // 清空所有验证提示
      }
    },
    formatestate(str){
      if(str==1){
        return '启用'
      }else{
        return '停用'
      }
    }

  },
}
</script>
<style>
#rccx .el-date-editor.el-input {
  width: 100px !important;
}

selectupwidth el-select {
  width: 120px;
}

/*#roleListpage .el-pager li.active {
  color: white;
}*/

#pdfdialog .el-dialog--small {
  top: 3% !important;
  width: 86% !important;
  height: 93% !important;
}

#scfrom .el-input.is-disabled .el-input__inner {
  background-color: white;
  border-color: white;
  color: #4e4e59;
  padding-bottom: 4px;
}

#scfrom .el-textarea.is-disabled .el-textarea__inner {
  background-color: white;
  border-color: #C0C4CC;
  color: #4e4e59;
  padding-bottom: 4px;
}
</style>